var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOpened)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.handleClickOutside),expression:"handleClickOutside"}],staticClass:"t-events-calendar-block",style:(_vm.style)},_vm._l((_vm.events),function(event){return _c('ui-popover-item',{key:event.id,attrs:{"event":event,"form":_vm.form}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/pages/events/components/popover/popover.vue?vue&type=template&id=14c3c516&
// module id = 1187
// module chunks = 0